/* src/components/features/journey-planning/Form/AdvancedOptions/AdvancedJourneyOptions.tsx */
import {
  TravelPreferences,
  type TravelFilters,
} from '../TravelPreferences/index';
import styles from './AdvancedJourneyOptions.module.css';
import { SvgIcon } from '../../../../base/Icon/SvgIcon';

interface AdvancedJourneyOptionsProps {
  filters: TravelFilters;
  onFiltersChange: (filters: TravelFilters) => void;
  open?: boolean;
  onToggle?: (isOpen: boolean) => void;
}

export function AdvancedJourneyOptions({
  filters,
  onFiltersChange,
  open,
  onToggle,
}: AdvancedJourneyOptionsProps) {
  const selectedTravelCount = filters.travel.length;

  const handleToggle = (e: Event) => {
    onToggle?.((e.currentTarget as HTMLDetailsElement).open);
  };

  return (
    <details className={styles.details} open={open} onToggle={handleToggle}>
      <summary className={styles.summary}>
        <div className={styles.titleContainer}>
          <span className={styles.title}>Advanced journey options</span>
          {selectedTravelCount > 0 && (
            <span className={styles.counter}>({selectedTravelCount})</span>
          )}
        </div>

        <SvgIcon name="chevronDown" className={styles.icon} />
      </summary>

      <div className={styles.travelPreferencesWrapper}>
        <TravelPreferences filters={filters} setFilters={onFiltersChange} />
      </div>
    </details>
  );
}
